import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";

import accountReducer from "./features/AccountPage/accountSlice";
import archivedListsReducer from "./features/ArchivedListPage/archivedListsSlice";
import remoteListsReducer from "./features/RemoteListsPage/remoteListsSlice";
import tasksReducer from "./features/tasks/tasksSlice";
import modalReducer from "./Modal/modalSlice";
import themeReducer from "./common/ThemeSwitch/themeSlice";
import rootSaga from "./rootSaga";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    tasks: tasksReducer,
    archivedLists: archivedListsReducer,
    remoteLists: remoteListsReducer,
    account: accountReducer,
    modal: modalReducer,
    theme: themeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
